module.exports = __webpack_public_path__ + "img/scapp_4@2x.83ff1804.png";